import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';
import type { MoneyMarketPageModel } from '../moneyMarketMonitor.types';

export function useMMFData(
  tfund: string | undefined,
  adate: string | undefined,
) {
  return useQuery<MoneyMarketPageModel, Error>({
    queryKey: ['mmf-data', tfund, adate],
    queryFn: () => getMMFData(tfund!, adate!),
    enabled: !!tfund && !!adate,
  });
}

export const getMMFData = async (
  tfund: string,
  adate: string,
): Promise<MoneyMarketPageModel> => {
  const { data } = await AxiosInstance.get<MoneyMarketPageModel>(
    `get_mmf_data/${tfund}/${adate}`,
  );
  return data;
};
